module.exports = __webpack_public_path__ + "img/team.720f75f0.png";